export const API_ENDPOINT = 'api-key';


// WEBPACK FOOTER //
// ./src/state/modules/api-key/configurations/endpoints.js